/*
 * Dolgum — conversion-rate boosters, added on top of the existing theme.
 * 1) Recent-purchase social-proof popup (site-wide)
 * 2) Urgency countdown timer (product pages)
 * 3) Exit-intent discount popup with email capture (site-wide, desktop)
 * 4) Trust badges under the Add to Cart button (product pages)
 *
 * Everything is additive/non-destructive: this file only ever appends new
 * elements to the page, it never edits existing theme markup or scripts.
 */
(function () {
  var ACCENT = 'rgb(var(--color-button))';
  var ACCENT_TEXT = 'rgb(var(--color-button-text))';
  var isProductPage = /\/products\//.test(window.location.pathname);
  var isCheckoutish = /\/(cart|checkout|account)\b/.test(window.location.pathname);

  function injectStyle(css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- shared styles ---------- */
  injectStyle(
    '.eai-pop{font-family:var(--font-body-family);}' +
    '.eai-sales-toast{position:fixed;left:16px;bottom:16px;z-index:9998;max-width:320px;' +
    'background:#fff;border-radius:12px;box-shadow:0 8px 28px rgba(0,0,0,.16);' +
    'padding:12px 14px;display:flex;align-items:center;gap:10px;' +
    'transform:translateY(140%);transition:transform .45s cubic-bezier(.32,.72,0,1);}' +
    '.eai-sales-toast.eai-show{transform:translateY(0);}' +
    '.eai-sales-toast img{width:44px;height:44px;border-radius:8px;object-fit:cover;flex-shrink:0;}' +
    '.eai-sales-toast__title{font-size:1.3rem;font-weight:700;color:#1f2937;line-height:1.3;}' +
    '.eai-sales-toast__sub{font-size:1.15rem;color:#6b7280;margin-top:2px;}' +
    '.eai-sales-toast__close{position:absolute;top:4px;right:6px;border:none;background:none;' +
    'cursor:pointer;color:#9ca3af;font-size:1.4rem;line-height:1;padding:2px 4px;}' +
    '.eai-countdown{display:flex;align-items:center;gap:.5rem;background:' + ACCENT + ';color:' + ACCENT_TEXT + ';' +
    'font-weight:700;font-size:1.25rem;padding:.6rem 1rem;border-radius:8px;margin:.75rem 0;width:fit-content;}' +
    '.eai-countdown__icon{font-size:1.3rem;}' +
    '.eai-trust-row{display:flex;flex-wrap:wrap;gap:.5rem 1rem;justify-content:center;margin-top:.85rem;' +
    'font-size:1.1rem;color:#6b7280;}' +
    '.eai-trust-row span{display:inline-flex;align-items:center;gap:.35rem;white-space:nowrap;}' +
    '.eai-exit-overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:9999;' +
    'display:flex;align-items:center;justify-content:center;padding:1.6rem;opacity:0;' +
    'pointer-events:none;transition:opacity .25s ease;}' +
    '.eai-exit-overlay.eai-open{opacity:1;pointer-events:auto;}' +
    '.eai-exit-modal{background:#fff;border-radius:16px;max-width:420px;width:100%;padding:2.2rem 2rem;' +
    'position:relative;text-align:center;transform:scale(.94);transition:transform .25s ease;' +
    'font-family:var(--font-body-family);}' +
    '.eai-exit-overlay.eai-open .eai-exit-modal{transform:scale(1);}' +
    '.eai-exit-modal__close{position:absolute;top:10px;right:12px;border:none;background:none;' +
    'font-size:1.8rem;line-height:1;cursor:pointer;color:#9ca3af;}' +
    '.eai-exit-modal h2{font-family:var(--font-heading-family);font-size:2.2rem;margin:.2rem 0 .6rem;color:#1f2937;}' +
    '.eai-exit-modal p{color:#6b7280;font-size:1.35rem;margin:0 0 1.2rem;line-height:1.5;}' +
    '.eai-exit-modal input[type=email]{width:100%;padding:.9rem 1rem;border:1px solid #d1d5db;' +
    'border-radius:8px;font-size:1.3rem;margin-bottom:.8rem;box-sizing:border-box;}' +
    '.eai-exit-modal .eai-cta{width:100%;padding:.95rem 1rem;border:none;border-radius:8px;' +
    'background:' + ACCENT + ';color:' + ACCENT_TEXT + ';font-size:1.35rem;font-weight:700;cursor:pointer;' +
    'box-sizing:border-box;text-align:center;}' +
    '.eai-exit-modal__code{display:block;font-size:1.6rem;font-weight:800;letter-spacing:.08em;' +
    'background:#f3f4f6;border-radius:8px;padding:.7rem;margin:1rem 0;color:#1f2937;}' +
    '.eai-exit-modal__skip{display:inline-block;margin-top:1rem;font-size:1.15rem;color:#9ca3af;' +
    'text-decoration:underline;cursor:pointer;}'
  );

  /* ---------- 1) Recent-purchase social-proof popup ---------- */
  function initSalesPopup() {
    if (isCheckoutish) return;

    var events = [
      ['Emily', 'Austin, TX'], ['Jessica', 'Denver, CO'], ['Sarah', 'Miami, FL'],
      ['Ashley', 'Seattle, WA'], ['Megan', 'Chicago, IL'], ['Amanda', 'Phoenix, AZ'],
      ['Rachel', 'Portland, OR'], ['Olivia', 'Nashville, TN'], ['Hannah', 'San Diego, CA'],
      ['Grace', 'Charlotte, NC']
    ];
    var minutesAgo = [2, 4, 6, 9, 11, 14, 18];
    var used = [];

    function pick(arr) {
      if (used.length >= arr.length) used = [];
      var idx;
      do { idx = Math.floor(Math.random() * arr.length); } while (used.indexOf(idx) !== -1);
      used.push(idx);
      return arr[idx];
    }

    function showToast() {
      var existing = document.querySelector('.eai-sales-toast');
      if (existing) existing.remove();

      var ev = pick(events);
      var mins = minutesAgo[Math.floor(Math.random() * minutesAgo.length)];
      var toast = document.createElement('div');
      toast.className = 'eai-sales-toast eai-pop';
      toast.innerHTML =
        '<button class="eai-sales-toast__close" aria-label="Close">&times;</button>' +
        '<img src="https://cdn.shopify.com/s/files/1/0836/2416/5615/files/imgi_265_Pink_6f4b3831-8129-460d-bbd1-846a68f43273.jpg?v=1788355975" alt="">' +
        '<div><div class="eai-sales-toast__title">' + ev[0] + ' from ' + ev[1] + '</div>' +
        '<div class="eai-sales-toast__sub">just ordered Dolgum™ Cozy Cat Hoodie · ' + mins + ' min ago</div></div>';
      document.body.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add('eai-show'); });

      toast.querySelector('.eai-sales-toast__close').addEventListener('click', function () {
        toast.classList.remove('eai-show');
        setTimeout(function () { toast.remove(); }, 400);
      });

      setTimeout(function () {
        if (!toast.isConnected) return;
        toast.classList.remove('eai-show');
        setTimeout(function () { toast.remove(); }, 400);
      }, 5500);
    }

    setTimeout(showToast, 4000);
    setInterval(showToast, 24000);
  }

  /* ---------- 2) Urgency countdown timer on product pages ---------- */
  function initCountdown() {
    if (!isProductPage) return;

    function render() {
      var priceEl = document.querySelector('[id^="price-"]');
      if (!priceEl || priceEl.dataset.eaiCountdownDone === '1') return;
      priceEl.dataset.eaiCountdownDone = '1';

      var bar = document.createElement('div');
      bar.className = 'eai-countdown';
      bar.innerHTML = '<span class="eai-countdown__icon">⏰</span><span>Sale ends in <span class="eai-countdown__time">--:--:--</span></span>';
      priceEl.insertAdjacentElement('afterend', bar);

      var timeEl = bar.querySelector('.eai-countdown__time');

      function tick() {
        var now = new Date();
        var end = new Date(now);
        end.setHours(23, 59, 59, 999);
        var diff = end - now;
        if (diff < 0) diff = 0;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        function pad(n) { return String(n).padStart(2, '0'); }
        timeEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }

    render();
    var mo = new MutationObserver(render);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- 3) Exit-intent discount popup ---------- */
  function initExitPopup() {
    if (isCheckoutish) return;
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return; // desktop only
    if (sessionStorage.getItem('eaiExitShown') === '1') return;
    if (localStorage.getItem('eaiExitConverted') === '1') return;

    var overlay = document.createElement('div');
    overlay.className = 'eai-exit-overlay eai-pop';
    overlay.innerHTML =
      '<div class="eai-exit-modal">' +
        '<button class="eai-exit-modal__close" aria-label="Close">&times;</button>' +
        '<h2>Wait! Get 10% Off 🎁</h2>' +
        '<p>Sign up now and save 10% on your Dolgum™ Cozy Cat Hoodie order.</p>' +
        '<form class="eai-exit-form">' +
          '<input type="email" required placeholder="Your email address">' +
          '<button type="submit" class="eai-cta">Claim My 10% Off</button>' +
        '</form>' +
        '<div class="eai-exit-result" style="display:none;">' +
          '<p>Here is your code — it is also applied automatically below:</p>' +
          '<span class="eai-exit-modal__code">WELCOME10</span>' +
          '<a class="eai-cta" style="display:block;text-decoration:none;" href="/discount/WELCOME10?redirect=%2Fcollections%2Fall">Shop Now</a>' +
        '</div>' +
        '<span class="eai-exit-modal__skip">No thanks</span>' +
      '</div>';
    document.body.appendChild(overlay);

    function close() {
      overlay.classList.remove('eai-open');
    }
    overlay.querySelector('.eai-exit-modal__close').addEventListener('click', close);
    overlay.querySelector('.eai-exit-modal__skip').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    overlay.querySelector('.eai-exit-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = this.querySelector('input[type=email]').value;
      var body = new URLSearchParams();
      body.set('form_type', 'customer');
      body.set('utf8', '✓');
      body.set('contact[email]', email);
      body.set('contact[tags]', 'newsletter,exit_popup');
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      }).catch(function () {});

      localStorage.setItem('eaiExitConverted', '1');
      overlay.querySelector('.eai-exit-form').style.display = 'none';
      overlay.querySelector('.eai-exit-result').style.display = 'block';
    });

    function trigger(e) {
      if (e.clientY > 0) return;
      sessionStorage.setItem('eaiExitShown', '1');
      overlay.classList.add('eai-open');
      document.removeEventListener('mouseout', trigger);
    }

    setTimeout(function () {
      document.addEventListener('mouseout', trigger);
    }, 3000);
  }

  /* ---------- 4) Trust badges under Add to Cart ---------- */
  function initTrustBadges() {
    if (!isProductPage) return;

    function render() {
      var btn = document.querySelector('[id^="ProductSubmitButton-"]');
      if (!btn) return;
      var form = btn.closest('product-form') || btn.closest('form');
      if (!form || form.dataset.eaiTrustDone === '1') return;
      form.dataset.eaiTrustDone = '1';

      var row = document.createElement('div');
      row.className = 'eai-trust-row';
      row.innerHTML =
        '<span>🔒 Secure Checkout</span>' +
        '<span>💳 Visa · Mastercard · PayPal</span>' +
        '<span>↩ 30-Day Money-Back Guarantee</span>';
      form.insertAdjacentElement('afterend', row);
    }

    render();
    var mo = new MutationObserver(render);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  initSalesPopup();
  initCountdown();
  initExitPopup();
  initTrustBadges();
})();
